const firebaseConfig = {
    apiKey: "AIzaSyAEh_uvy11ryU_h9qXDv5Lgm-5vzUHv5Xk",
    authDomain: "freelancersplace-live.firebaseapp.com",
    projectId: "freelancersplace-live",
    storageBucket: "freelancersplace-live.appspot.com",
    messagingSenderId: "406754206518",
    appId: "1:406754206518:web:d2ceb609fa130adb64c997"
  };

  export default firebaseConfig;